import { IPackageCart } from 'Services/invoice/invoicePackageStoreService';
import { invoicePackageKeyStore } from 'Store/keyStore'

interface state {
    cartPackageSelected: string,
    currentStep: number,
    cart: Array<IPackageCart>
}

const getters = {
    [invoicePackageKeyStore.CURRENT_STEP]: (state: state): number => {
        return state.currentStep;
    },
    [invoicePackageKeyStore.CART]: (state: state): IPackageCart[] => {
        return state.cart;
    },
    [invoicePackageKeyStore.CART_PACKAGE_SELECTED]: (state: state) => {
        const selected = state.cartPackageSelected;
        state.cartPackageSelected = "";
        return selected;
    }
}

const mutations = {
    [invoicePackageKeyStore.CURRENT_STEP]: (state: state, val: any) => {
        state.currentStep = val;
    },
    [invoicePackageKeyStore.CART]: (state: state, req: IPackageCart[]) => {
        state.cart = req;
    },
    [invoicePackageKeyStore.CART_PACKAGE_SELECTED]: (state: state, val: string) => {
        state.cartPackageSelected = val;
    }
}

export default {
    mutations: mutations,
    getters: getters
};

